export function getLocationUrl() {
  // If params are included, return the url which will get passed to getTour and load specific tour location
  const params = ['s=', 'x=', 'y='];
  const hasParams = params.every((param) => window.location.href.includes(param));
  const url = hasParams ? window.location.href : null;

  return url;
}
